/* Cards in a row share the tallest title height so their excerpt zones align
   (mirrors glymedplus.com education cards). Active on .blog-articles--equalize
   grids (main-blog "Equalize card title heights" setting). */
(() => {
  const equalize = () => {
    document.querySelectorAll('.blog-articles--equalize').forEach((grid) => {
      const headings = [...grid.querySelectorAll('.card__heading')];
      headings.forEach((heading) => {
        heading.style.minHeight = '';
      });
      const rows = {};
      headings.forEach((heading) => {
        const item = heading.closest('.blog-articles__article') || heading;
        const top = Math.round(item.offsetTop);
        (rows[top] = rows[top] || []).push(heading);
      });
      Object.values(rows).forEach((group) => {
        if (group.length < 2) return;
        const max = Math.max(...group.map((heading) => heading.getBoundingClientRect().height));
        group.forEach((heading) => {
          heading.style.minHeight = `${max}px`;
        });
      });
    });
  };

  let timer;
  const debounced = () => {
    clearTimeout(timer);
    timer = setTimeout(equalize, 100);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', equalize);
  } else {
    equalize();
  }
  if (document.fonts?.ready) {
    document.fonts.ready.then(equalize);
  }
  window.addEventListener('resize', debounced);
  document.addEventListener('shopify:section:load', debounced);
})();
